import React from 'react';

module.exports = (props) => {

  return (
    <div className="erro">
      <p>
        Atenção, caro representante, este fornecedor está com pontuação igual ou inferior a 5 pontos, portanto não é permitido mais utilizar o sistema.
        Por favor, entre em contato com o setor de compras.
      </p>
    </div>
  );

};


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/aviso-nota-fornecedor.js
 **/